// https://github.com/apal21/nextjs-progressbar/issues/86
"use client";

import { useEffect } from "react";
import NProgress from "nprogress";
import useTheme from "@mui/material/styles/useTheme";
import GlobalStyles from "@mui/material/GlobalStyles";

const ProgressBar = () => {
  const theme = useTheme();
  useEffect(() => {
    void import("nprogress/nprogress.css").then(() => {
      NProgress.configure({
        showSpinner: false,
      });

      const handleDocumentClick = (event) => {
        if (event.defaultPrevented) return;
        if (event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const anchor = event.target?.closest?.("a[href]");
        if (!anchor) return;
        if (anchor.target === "_blank") return;
        if (anchor.hasAttribute("download")) return;
        if (anchor.getAttribute("rel") === "external") return;

        const targetUrl = anchor.href;
        const currentUrl = location.href;
        if (targetUrl !== currentUrl) {
          NProgress.start();
        }
      };

      const originalPushState = window.history.pushState;
      const originalReplaceState = window.history.replaceState;
      window.history.pushState = new Proxy(window.history.pushState, {
        apply: (target, thisArg, argArray) => {
          NProgress.done();
          return target.apply(thisArg, argArray);
        },
      });
      window.history.replaceState = new Proxy(window.history.replaceState, {
        apply: (target, thisArg, argArray) => {
          NProgress.done();
          return target.apply(thisArg, argArray);
        },
      });

      const handlePageReady = () => NProgress.done();
      document.addEventListener("click", handleDocumentClick);
      window.addEventListener("popstate", handlePageReady);
      window.addEventListener("pageshow", handlePageReady);

      return () => {
        document.removeEventListener("click", handleDocumentClick);
        window.removeEventListener("popstate", handlePageReady);
        window.removeEventListener("pageshow", handlePageReady);
        window.history.pushState = originalPushState;
        window.history.replaceState = originalReplaceState;
      };
    });
  }, []);
  return (
    <GlobalStyles
      styles={{
        "#nprogress": {
          pointerEvents: "none",
          ".bar": {
            top: 0,
            left: 0,
            height: 2,
            width: "100%",
            position: "fixed",
            zIndex: 9999999999,
            background: theme.palette.primary.main,
          },
          ".peg": {
            right: 0,
            opacity: 1,
            width: 100,
            height: "100%",
            display: "block",
            boxShadow: "none",
            position: "absolute",
            transform: "rotate(3deg) translate(0px, -4px)",
          },
        },
      }}
    />
  );
};

export default ProgressBar;
